import logger from '../log';
import { ElevenDataContainer, ElevenDataRequestState } from './interfaces';
import { safeSave, safeGet } from '../util/storage';
import BaseLogger from '../log/Logger';

const log = logger.getLogger(__filename);

const elevenData = 'ksdk::common::eleven::agentData';

const { NOTCALLED } = ElevenDataRequestState;

export function setElevenData(data: ElevenDataContainer): void {
  safeSave({
    error: 'Failed setting Eleven Data',
    key: elevenData,
    log: log as BaseLogger,
    data
  });
}

export function getElevenData(playGuid: string): ElevenDataContainer {
  const ts = 0;
  const data: ElevenDataContainer = safeGet({
    error: 'Failed fetching Eleven Data',
    nonExistenceError: 'No Eleven Data to fetch',
    default: { state: NOTCALLED, playGuid, ts },
    log: log as BaseLogger,
    key: elevenData
  });
  if (data.playGuid === playGuid) {
    return data;
  }
  return { state: NOTCALLED, playGuid, ts };
}
